module.exports = __webpack_public_path__ + "static/img/auto-play-guide.6228024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/auto-play-guide.png
// module id = rqnV
// module chunks = 28